import { RiwayatPendidikanResponse } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function riwayatPendidikan(
  RIWAYAT_PENDIDIKAN_ID: number
): Promise<RiwayatPendidikanResponse> {
  const res = await ApiClient.get(
    `/Pendidikan?RIWAYAT_PENDIDIKAN_ID=${RIWAYAT_PENDIDIKAN_ID}`
  );
  return res.data[0];
}

export const useFetchRiwayatPendidikan = mutationWrapper(riwayatPendidikan);
